import { GetStaticProps, NextPage } from 'next'
import { ComponentProps } from 'react'
import { Layout } from '~/components/Layout'
import { Meta } from '~/components/Meta'
import { Custom404 } from '~/features/404/404'
import { OTHER_HEADER_ADJUST_URL } from '~/lib/constants'

type Props = ComponentProps<typeof Custom404>

const Custom404Page: NextPage<Props> = () => {
  const breadcrumb = [{ name: 'ご指定のページが見つかりません' }]

  return (
    <Layout
      appDownloadUrl={OTHER_HEADER_ADJUST_URL}
      breadcrumbList={breadcrumb}
      headerProps={{ headerType: 'border' }}
      appUrl={undefined}
      abstractUrl="wear.jp/404/"
    >
      <Meta
        title="ご指定のページが見つかりません"
        description={undefined}
        url={undefined}
        appUrl={undefined}
      />
      <Custom404 />
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  }
}

export default Custom404Page
